// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__zP1rt","paramInput":"JobSimulator_paramInput__2KSUH","input":"JobSimulator_input__3nXsT"};